type Row = { rank: string; title: string; tag: string; views: string; badge?: string };

const ROWS: Row[] = [
  { rank: "02", title: "地铁上那句夸奖，换来十几站无声", tag: "地铁偶遇", views: "96.3w" },
  { rank: "03", title: "咖啡店加微信失败，店员都看愣住", tag: "咖啡店", views: "210.4w" },
  { rank: "04", title: "网聊三个月奔现，见面双双沉默", tag: "网络奔现", views: "243.8w" },
  { rank: "05", title: "酒局壮胆表白，结果对方是甲方", tag: "酒局", views: "156.1w" },
  { rank: "06", title: "相亲被问房车，他答非所问聊起猫", tag: "相亲局", views: "134.5w" },
];

const TRENDING = ["热搜第一", "爆款预定", "全网热议", "持续走红"];

export default function TopList() {
  return (
    <section id="top" className="bg-white py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
          <div>
            <p className="mb-2 inline-flex items-center gap-2 rounded-full bg-amber-400 px-3 py-1 text-xs font-semibold text-stone-900">
              <i className="ri-trophy-fill" /> 热度实时
            </p>
            <h2 className="font-hand text-3xl text-stone-900 md:text-4xl">本周名场面 TOP 榜</h2>
          </div>
          <a
            href="#feed"
            className="whitespace-nowrap text-sm font-semibold text-orange-600 transition-colors hover:text-orange-700"
          >
            查看更多榜单 <i className="ri-arrow-right-line ml-1" />
          </a>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-5">
          {/* 冠军名场面 */}
          <div className="lg:col-span-2">
            <article className="group relative flex h-full min-h-[420px] w-full flex-col justify-end overflow-hidden rounded-3xl">
              <img
                src="https://readdy.ai/api/search-image?query=epic%20flat%20cartoon%20illustration%20of%20the%20most%20legendary%20awkward%20flirtation%20failure%20scene%20where%20a%20young%20man%20drops%20ice%20cream%20on%20his%20shoes%20while%20nervously%20talking%20to%20a%20girl%2C%20crowd%20watching%20in%20amazement%2C%20vibrant%20orange%20amber%20and%20cream%20flat%20vector%20illustration%20style%2C%20dramatic%20funny%20comic%20composition%2C%20warm%20sunlight%2C%20high%20detail%20playful%20mood&width=900&height=1200&seq=top-champion&orientation=portrait"
                alt="本周冠军名场面：雪糕掉鞋上的史诗级翻车"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
              <div className="relative z-10 p-6 md:p-8">
                <span className="inline-flex items-center gap-1 rounded-full bg-amber-400 px-3 py-1 text-xs font-bold text-stone-900">
                  <i className="ri-star-fill" /> TOP 01 · 年度冠军
                </span>
                <h3 className="font-hand mt-4 text-2xl leading-snug text-white md:text-3xl">
                  街角告白太紧张 <br className="hidden md:block" />
                  冰淇淋掉在脚背上
                </h3>
                <p className="mt-3 line-clamp-2 text-sm text-white/80">
                  全网点赞量突破千万的社死名场面：想说得浪漫一点，结果手里的甜筒先替他表白地板。
                </p>
                <div className="mt-5 flex items-center gap-5 text-sm text-white/85">
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-eye-line" /> 986.4w
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-thumb-up-line" /> 32.1w
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-message-3-line" /> 8.7w
                  </span>
                </div>
                <a
                  href="#feed"
                  className="mt-6 inline-flex whitespace-nowrap items-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-semibold text-stone-900 transition-colors hover:bg-amber-200"
                >
                  围观名场面 <i className="ri-play-fill" />
                </a>
              </div>
            </article>
          </div>

          {/* 榜单列表 */}
          <div className="flex flex-col gap-3 lg:col-span-3">
            {ROWS.map((r, idx) => (
              <a
                key={r.rank}
                href="#feed"
                className="group flex items-center gap-4 rounded-2xl border border-stone-200 bg-orange-50/50 p-4 transition-colors hover:border-orange-300 hover:bg-orange-50 md:gap-6 md:p-5"
              >
                <span
                  className={`font-hand w-12 shrink-0 text-center text-2xl md:w-16 md:text-3xl ${
                    idx === 0 ? "text-orange-500" : "text-stone-300"
                  }`}
                >
                  {r.rank}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="truncate text-sm font-semibold text-stone-900 md:text-base">
                      {r.title}
                    </h3>
                    <span className="hidden whitespace-nowrap rounded-full bg-teal-100 px-2 py-0.5 text-[11px] font-medium text-teal-700 sm:inline-flex">
                      {TRENDING[idx % TRENDING.length]}
                    </span>
                  </div>
                  <p className="mt-1 text-xs text-stone-500 md:text-sm">
                    栏目：{r.tag} · {r.views} 播放
                  </p>
                </div>
                <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full border border-orange-300 text-orange-500 transition-colors group-hover:bg-orange-500 group-hover:text-white">
                  <i className="ri-play-fill text-lg" />
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}